import React, { useState } from 'react';
import {
  Box, VStack, Heading, Input, Button, Text, useToast, Flex,
} from '@chakra-ui/react';
import api from '../api';

export default function ResetPasswordPage({ token, onComplete }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  const toast = useToast();

  const handleReset = async () => {
    if (password.length < 8) { toast({ title: 'Password must be at least 8 characters', status: 'warning', duration: 2000 }); return; }
    if (password !== confirmPassword) { toast({ title: 'Passwords do not match', status: 'warning', duration: 2000 }); return; }
    setSaving(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      toast({ title: 'Password reset successfully', status: 'success', duration: 3000 });
      setDone(true);
    } catch(e) {
      toast({ title: e.response?.data?.error || 'Reset failed', status: 'error', duration: 3000 });
    } finally { setSaving(false); }
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50">
      <Box bg="white" p={8} borderRadius="lg" shadow="md" maxW="400px" w="100%">
        <VStack spacing={4}>
          <Heading size="md" color="gray.700">Reset Password</Heading>
          {done ? (
            <>
              <Text color="green.600" textAlign="center">Your password has been reset. You can now log in.</Text>
              <Button w="100%" bg="brand.600" color="white" _hover={{ bg:'brand.700' }}
                onClick={onComplete}>Go to Login</Button>
            </>
          ) : (
            <>
              <Text color="gray.500" textAlign="center">Enter your new password below.</Text>
              <Input type="password" placeholder="New password (min 8 chars)" value={password}
                onChange={e => setPassword(e.target.value)} />
              <Input type="password" placeholder="Confirm password" value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleReset(); }} />
              <Button w="100%" bg="brand.600" color="white" _hover={{ bg:'brand.700' }}
                onClick={handleReset} isLoading={saving}>Reset Password</Button>
              <Button size="sm" variant="ghost" onClick={onComplete}>Back to Login</Button>
            </>
          )}
        </VStack>
      </Box>
    </Flex>
  );
}
